import styled from 'styled-components';

import { InteractiveTable, Tooltip } from '@dreryk/react-components';

export const StyledTooltip = styled(Tooltip)`
   width: 100%;
`;

StyledTooltip.displayName = 'StyledTooltip';

export const StyledUnitSelectCell = styled(InteractiveTable.SelectCell)`
   max-height: 160px;
` as typeof InteractiveTable.SelectCell;
